var React = require('react');

function Account (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M12 10.3c1.3.6 2 1.3 2 2.2V14H2v-1.5c0-1 .7-1.6 2-2.2 1.4-.5 2.8-.8 4-.8 1.3 0 2.6.3 4 .8zM8 8c1.7 0 3-1.3 3-3S9.7 2 8 2 5 3.3 5 5s1.3 3 3 3z"}));
}

Account.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Account;

Account.default = Account;
